import { useEffect, useRef } from 'react'
import { FormRenderer, type TextInputRules } from '@/core/components/form/FormRenderer'
import { ScrollBar } from 'admination-react'
import { useListActionsSink } from '@/core/components/list/listActions'
import { stammdatenForm } from '@/core/templates'
import type { FormValues } from '@/core/components/form/formModel'
import type { FieldErrors } from '@/core/lib/fieldError'
import type { FieldId } from '@/core/lib/result'

export const STAMMDATEN_INPUT_RULES: TextInputRules = new Map([
  ['Kontakt.PLZ', { filter: /[0-9]/, inputMode: 'numeric', maxLength: 5 }],
  ['Kontakt.Telefon', { filter: /[0-9 +\-/()]/ }],
])

export function StammdatenTab({ values, onChange, errors, manualFields, onSave, saving = false }: {
  values: FormValues
  onChange: (path: string, value: unknown) => void
  errors?: FieldErrors
  manualFields: ReadonlySet<FieldId>
  onSave: () => void
  saving?: boolean
}) {
  const scrollerRef = useRef<HTMLElement>(null)
  const onSaveRef = useRef(onSave)
  onSaveRef.current = onSave
  const sink = useListActionsSink()
  useEffect(() => {
    if (!sink) return
    sink({
      actions: [{ id: 'save', label: 'Speichern', icon: 'i-check', primary: true, loading: saving }],
      onRun: (id) => { if (id === 'save') onSaveRef.current() },
    })
    return () => sink(null)
  }, [sink, saving])

  return <>
    <main className="form" data-scroll-host ref={scrollerRef}>
      <div className="form-sheet">
        <FormRenderer
            definition={stammdatenForm}
            values={values}
            onChange={onChange}
            errors={errors}
            field={(field) => ({
              required: manualFields?.has(field.id),
              missing: manualFields?.has(field.id) ? 'mark' : undefined,
              ...STAMMDATEN_INPUT_RULES?.get(field.id),
            })}
          />
      </div>
    </main>
    <ScrollBar scrollerRef={scrollerRef} />
  </>
}
